const Accordion = () => ({
  isCollapsed(element) {
    return element.getAttribute('aria-expanded') !== 'true';
  },

  unfold(control, panel) {
    panel.removeAttribute('hidden');
    panel.removeAttribute('aria-hidden');
    control.setAttribute('aria-expanded', 'true');
  },

  collapse(control, panel) {
    panel.setAttribute('hidden', '');
    panel.setAttribute('aria-hidden', 'true');
    control.setAttribute('aria-expanded', 'false');
  },

  bindControlEvents() {
    this.controls.forEach((control, controlIndex) => {
      control.addEventListener('click', (event) => {
        event.preventDefault();

        const clickTarget = event.target;
        const panel = this.panels[controlIndex];

        const isCollapsed = this.isCollapsed(clickTarget);

        if (isCollapsed) {
          this.unfold(clickTarget, panel);
        } else {
          this.collapse(clickTarget, panel);
        }
      });

      control.addEventListener('keydown', (event) => {
        const focusTarget = event.target;
        const panel = this.panels[controlIndex];

        const controlCount = this.controls.length;

        switch (event.key) {
          // When focus is on an accordion header, moves focus to the next accordion header.
          // When focus is on last accordion header, moves focus to first accordion header.
          case 'ArrowUp':
          case 'PageUp': {
            event.preventDefault();

            const newIndex = (controlIndex + controlCount - 1) % controlCount;
            this.controls[newIndex].focus();
            break;
          }
          // When focus is on an accordion header, moves focus to the previous accordion header.
          // When focus is on first accordion header, moves focus to last accordion header.
          case 'ArrowDown':
          case 'PageDown': {
            event.preventDefault();

            const newIndex = (controlIndex + controlCount + 1) % controlCount;
            this.controls[newIndex].focus();
            break;
          }
          // When focus is on an accordion header, moves focus to the first accordion header.
          case 'Home': {
            event.preventDefault();

            this.controls[0].focus();
            break;
          }
          // When focus is on an accordion header, moves focus to the last accordion header.
          case 'End': {
            event.preventDefault();

            this.controls[this.controls.length - 1].focus();
            break;
          }
          // When focus is on the accordion header of a collapsed section, expands the section.
          case ' ':
          case 'Enter': {
            event.preventDefault();
            const isCollapsed = this.isCollapsed(event.target);
            if (isCollapsed) {
              this.unfold(focusTarget, panel);
            }
            break;
          }
          default: {
            break;
          }
        }
      });
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'PageUp': {
            event.preventDefault();

            // When focus is inside an accordion panel, moves focus to the header for that panel.
            this.controls[panelIndex].focus();
            break;
          }
          case 'PageDown': {
            event.preventDefault();

            // When focus is inside an accordion panel moves focus to the next accordion header.
            // When focus is inside last accordion panel, moves focus to first accordion header.
            if (this.controls[panelIndex + 1]) {
              this.controls[panelIndex + 1].focus();
            } else {
              this.controls[0].focus();
            }
            break;
          }
          default: {
            break;
          }
        }
      });
    });
  },

  init() {
    this.controls = this.$root.querySelectorAll('.accordion__button');
    this.panels = this.$root.querySelectorAll('.accordion__panel');

    this.bindControlEvents();
  }
});

export default Accordion;
